var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isAmp
        ? _c("sports-tabs", {
            attrs: {
              parentRoute: _vm.parentRoute,
              eventChangeHandler: _vm.eventChangeHandler,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAmp
        ? _c("category-header", {
            attrs: {
              loadUpdatedContestList: function () {
                return !1
              },
              parentRoute: _vm.parentRoute,
              loaded_module: _vm.loaded_module,
              eventChangeHandler: _vm.eventChangeHandler,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAmp
        ? _c("carousal", {
            attrs: {
              parentRoute: _vm.parentRoute,
              loaded_module: _vm.loaded_module,
              componentSlideChnageHandler: _vm.eventChangeHandler,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAmp
        ? _c("page-tabs", {
            attrs: {
              parentRoute: _vm.parentRoute,
              current_match: _vm.current_match,
            },
          })
        : _c("page-tabs", {
            attrs: {
              parentRoute: _vm.parentRoute,
              loaded_module: _vm.loaded_module,
              checkIfTourIsActive: function () {
                return !1
              },
              current_match: _vm.current_match,
            },
          }),
      _vm._v(" "),
      _c("Breadcrumbs", {
        attrs: {
          parentRoute: _vm.parentRoute,
          current_match: _vm.current_match,
          titleTrans: _vm.translations[_vm.breadcrumbTransKey],
          sequence: [
            { type: "base", page: "home" },
            {
              type: "module",
              module: _vm.parentRoute,
              blockSlice: _vm.blockBreadcrumbLink,
            },
            {
              type: "param",
              param: "sport_name",
              blockSlice: _vm.blockBreadcrumbLink,
            },
            { type: "title" },
          ],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }